import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap';

export class BsModalEventsEmitter {
    private readonly bsModalStateChanged: Subject<BsModalRef> = new Subject();

    bsModalStateChanged$ = this.bsModalStateChanged.asObservable();

    broadcastBsModalStateChanged(state: BsModalRef) {
        this.bsModalStateChanged.next(state);
    }
}
